import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import { Capture } from 'yunkecom/dist/utils';
import { BecomeDueModal } from 'yunkecom';
import App from '@/App';
import { userService } from '@/service';
import Cookie from 'js-cookie';
import CheckCache from './CheckCache';
import { version } from '../package.json';
import 'antd/dist/reset.css';
import './styles.module.less';

const params = new URLSearchParams(window.location.search);
const token = params.get('token');
const userId = params.get('userId');
const cookie = params.get('cookie');

if (import.meta.env.VITE_APP_PRIVATE === 'yunke' || import.meta.env.VITE_APP_PRIVATE === 'tanke') {
  const capture = new Capture({
    dsn: 'https://69fe00b478252e63ce86f0be7030ca90@sentry.yunkecn.com/7',
    release: version,
    env: import.meta.env.MODE,
  });
  window.capture = capture;
}
/**
 * 手机页面调用pc接口需要登录
 */
const loadData = async () => {
  if (token && userId) {
    const response = await userService.getLoginSign({ token, userId });
    if (response.success && response.data) {
      const { signature, ...data } = response.data;
      await userService.login({ sign: signature, ...data });
    }
  }
};
/**
 *读取缓存icon
 */
const getLinkIcon = () => {
  const channelInfo = localStorage.getItem('channelInfo') !== 'undefined' ? JSON.parse(localStorage.getItem('channelInfo')) : {};
  if (channelInfo?.urlLogo) {
    let link = document.querySelector('link[rel="shortcut icon"]') || document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      document.getElementsByTagName('head')[0]?.appendChild(link);
    }
    link.href = channelInfo.urlLogo;
  }
};

function render() {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <Router
      basename={window.location.href.includes('/cms/wechat') ? '/cms/wechat' : '/sub-wechat'}
    >
      {(window.location.pathname.includes('sub-wechat') || Cookie.get('user') || window.top !== window.self) ? null : <BecomeDueModal />}
      <CheckCache />
      <App />
    </Router>,
  );
}
getLinkIcon();
loadData();
render();
